import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    messageList: null,
    loading: false,
    error: null,
    sending: null
};

export const getMessageList = createAsyncThunk(
    "getMessageList",
    async (data) => {


        try {
            const response = await instance.get
                (`remark/remarkticket/get-messages?ticket_id=${data}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const sendMessage = createAsyncThunk(
    "sendMessage",
    async (body) => {

        const formData = new FormData();
        formData.append("ticket_id", body.ticket_id);
        formData.append("sender_id", body.sender_id);
        formData.append("message", body.message);
        formData.append("user_type", "crm");
        try {
            const response = await instance.post
                (`remark/remarkticket/send-messages`, formData
                );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const RemarkTicketConversationSlice = createSlice({
    name: "RemarkTicketConversationSlice",
    initialState,

    reducers: {
        addMessage(state, action) {
            // debugger ;
            state.messageList.push(action.payload); // Local state update
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getMessageList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getMessageList.fulfilled, (state, action) => {
            state.loading = false;
            state.messageList = action.payload?.data;
        });
        builder.addCase(getMessageList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        // builder.addCase(sendMessage.pending, (state, action) => {
        //     state.loading = true;
        // });
        // builder.addCase(sendMessage.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.sending = action.payload?.data;
        // });
        // builder.addCase(sendMessage.rejected, (state, action) => {
        //     state.loading = false;
        //     state.error = action.payload;
        // });

    },
});

export default RemarkTicketConversationSlice.reducer;
export const { addMessage } = RemarkTicketConversationSlice.actions;
